@if (component && variants && component.isVisible && component.component) {
<div class="customizer-element" [ngClass]="{'expanded': menuService.subMenuIsExpanded, 'visible': component}" [@fadeInOutTransition] [@grow] (@grow.done)="show($event)">
	@if (isReady) {
	<ndc-dynamic
		[ndcDynamicAttributes]="{ class: 'component' }"
		[ndcDynamicInputs]="{
			reference: reference,
			comment: comment,
			engraving: engraving,
			configurations : configurations,
			configuration: configuration,
			variants: variants,
			imageOnlyVariants: imageOnlyVariants,
			modelSize: modelSize,
			modelGroup: modelGroup,
			model: model,
			menu: component,
			state: state,
			currentVariantConstant: currentVariantConstant,
			hasForms: hasForms,
			hasFixtures: hasFixtures,
			discount: discount,
			discountErrors: discountErrors,
			age: age,
			gender: gender,
			firstPair: firstPair,
			selectedTempleInclination: selectedTempleInclination,
			selectedCase: selectedCase,
			isLimited: isLimited
		}"
		[ndcDynamicComponent]="asAny()"
		[ndcDynamicOutputs]="outputs"
	>
	</ndc-dynamic>
	}
</div>
}